<template>

    <div class="mt-2">
        <v-chip v-for="(name, index) in subPanelNames" :key="index"
                color="grey darken-1"
                text-color="white"
                label
                small
                class="mr-1"
        >
            {{ shorten(name) }}
        </v-chip>
    </div>
</template>

<script>

    export default {

        props: {
            selected: {
                required: false,
                type: Array,
                default: () => []
            },
        },

        computed: {
            subPanelNames() {

                if (this.$store.state.SubPanels.subPanels) {

                    let names = [];

                    this.selected.forEach((selectedId) => {
                        let found = this.$store.state.SubPanels.subPanels.find((subPanel) => {
                            return subPanel.id === selectedId;
                        });

                        if (found) names.push(found.name);
                    });
                    return names;
                }
            }
        },

        methods: {

            shorten(categoryName) {
                return categoryName.replace(/^(.{20}[^\s]*).*/, "$1");
            }
        },
    }
</script>
